"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationBuilding = function IllustrationBuilding() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "67",
    height: "68",
    fill: "none",
    viewBox: "0 0 67 68"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "1",
    y: "3",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M1 61h65"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M13.371 60.631h39.843v-20.08L33.293 24.252 13.37 40.788V60.63z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M18.366 31.76v-7.508h3.378v4.909M13.371 60.631h39.843v-20.08L33.293 24.252 13.37 40.788V60.63z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.31 19.633L10.155 38.93v4.764L33.31 24.402l23.075 18.946v-4.764L33.31 19.633z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M28.055 40.998H38.449V60.631H28.055z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    d: "M28.055 57.744H38.449V60.631H28.055z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M28.055 40.998H38.449V60.631H28.055z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M17.084 40.998H24.591V50.236999999999995H17.084z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M41.914 40.998H49.421V50.236999999999995H41.914z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    d: "M17.084 47.927H24.591V50.237H17.084z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4F1F6",
    d: "M41.914 47.927H49.421V50.237H41.914z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M17.084 40.998H24.591V50.236999999999995H17.084z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M41.914 40.998H49.421V50.236999999999995H41.914z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    fillRule: "evenodd",
    d: "M14.589 6.414c0 .55.125 1.07.35 1.533a2.548 2.548 0 001.428 4.316 3.527 3.527 0 106.683 2.255 4.115 4.115 0 00-1.434-7.675 3.526 3.526 0 10-7.027-.43z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    d: "M23.702 2.838a1.42 1.42 0 10.002-2.84 1.42 1.42 0 00-.002 2.84zM17.499 20.46a.991.991 0 10.001-1.983.991.991 0 00-.001 1.982z"
  }));
};

var _default = IllustrationBuilding;
exports.default = _default;